module.exports = __webpack_public_path__ + "img/geprüfter-NWF-TN-Siegel.8686b2e4.png";